<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="MailAccountConfigurations"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <DIV
    class="overflow-auto h-100 p-3"
    v-if="loaded"
  >
    <ItpBox
      alignItems="center"
      class="mb-3"
    >
      <strong>
        {{ 'Email account configurations'|pgettext('MailAccountConfigurations') }}
      </strong>
      <ItpButton
        icon="fa-sync-alt"
        :text="'Reload'|gettext"
        variant="light"
        size="sm"
        :spinning="actions.reload.isRunning"
        class="ml-3"
        @click.prevent.stop="evh_8320016629450276_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        :text="'Add account...'|pgettext('MailAccountConfigurations')"
        variant="light"
        size="sm"
        class="ml-3"
        @click.prevent.stop="evh_6705964765214521_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        icon="fa-file-invoice"
        :text="'Export'|pgettext('MailAccountConfigurations')"
        variant="light"
        size="sm"
        :disabled="!items || !items.length"
        use-auth
        force-download
        downloadFileName="mail-account-configurations.yaml"
        :href="$fn.urlFor('export_object_by_type', {object_type: objectType})"
        class="ml-3"
      >
      </ItpButton>
      <ItpButton
        icon="fa-file-invoice"
        :text="'Import'|pgettext('MailAccountConfigurations')"
        variant="light"
        size="sm"
        class="ml-3"
        @click.prevent.stop="evh_8116269939469002_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
    <ItpDataTable
      tableId="Settings.MailAccountConfigurations"
      :editable="b_3343864469950044_editable"
      :value="items"
      :globs="{ openMailAccountConfig }"
      :columns="b_3343864469950044_columns"
      class="h-100"
      ref="table"
      v-if="loaded"
    >
    </ItpDataTable>
  </DIV>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "settings.mailAccounts",
    path: "mail-accounts",
    component: "MailAccountConfigurations"
  }
)

@Component()
export default class MailAccountConfigurations extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  openMailAccountConfig(...args: any[]) {
    const [oid] = args;
    const updateItem = this.updateItem;

    return this.$imodal
      .show({
        name: 'MailAccountConfig',
        props: { oid }
      })
      .then(res => this.loadData('items'))
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  objectType!: any;
  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_object_by_type', { parameters: { object_type: this.$data.objectType } })
      .then(items => _.orderBy(items, ['created_at'], ['asc']))
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_3343864469950044_editable!: any;
  b_3343864469950044_columns!: any;
  dataMembers = ['objectType', 'items', 'ux', 'b_7315092382398562_modalBindings', 'b_3343864469950044_editable', 'b_3343864469950044_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        objectType: "mail-account",
        items: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_3343864469950044_editable: false,
        b_3343864469950044_columns: [{
          name: "id",
          header: this.$fn.pgettext("MailAccountConfig", "ID"),
          width: "180px",
          formatter: {
            name: "template",
            value: "<div>\n\
  <a class=\"text-nowrap\"\n\
     href=\"#\"\n\
     @click=\"globs.openMailAccountConfig(row.id)\"\n\
  >\n\
    {{ value }}\n\
  </a>\n\
</div>\n\
",
          }
          ,
        }
          ,
        {
          name: "address",
          header: this.$fn.pgettext("MailAccountConfig", "Address"),
          width: "180px",
        }
          ,
        {
          name: "description",
          header: this.$fn.pgettext("MailAccountConfig", "Description"),
          width: "200px",
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return
    }
    return null;
  }

  async act_7315092382398562_closeModal_5452_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5452, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_8320016629450276_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_6705964765214521_script_5456_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6705964765214521_script_5456, alias=undefined
    this.openMailAccountConfig()
  }

  async act_6705964765214521_script_5456_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6705964765214521_script_5456, alias=undefined
    return {
      value: () => this.act_6705964765214521_script_5456_getActionArgs_value($event),
    }
  }

  async evh_6705964765214521_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6705964765214521_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_8116269939469002_showModal_5458_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8116269939469002_showModal_5458, alias=undefined
    return {
      name: "FileSelector",
      props: {
        url: this.$fn.urlFor('import_mail_account_config'),
        accept: ".yaml",
      }
      ,
    }
  }

  async evh_8116269939469002_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8116269939469002_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5452: actions.CloseModalAction;
    evh_7315092382398562_close_5451: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_8320016629450276_reloadComponentData_5454: actions.ReloadComponentDataAction;
    evh_8320016629450276_clickPreventStop_5453: actions.EventHandlerImpl;
    evh_8320016629450276_clickPreventStop: actions.EventHandlerGroup;
    act_6705964765214521_script_5456: actions.ScriptAction;
    evh_6705964765214521_clickPreventStop_5455: actions.EventHandlerImpl;
    evh_6705964765214521_clickPreventStop: actions.EventHandlerGroup;
    act_8116269939469002_showModal_5458: actions.ShowModalAction;
    evh_8116269939469002_clickPreventStop_5457: actions.EventHandlerImpl;
    evh_8116269939469002_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5452 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5452_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5451 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5452,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5451],
      }
    );
    const act_8320016629450276_reloadComponentData_5454 = new actions.ReloadComponentDataAction(
      {
        displayName: "reload",
        events: [],
      }
    );
    const evh_8320016629450276_clickPreventStop_5453 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_reloadComponentData_5454,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_8320016629450276_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_clickPreventStop_5453],
      }
    );
    const act_6705964765214521_script_5456 = new actions.ScriptAction(
      {
        actionArgs: this.act_6705964765214521_script_5456_getActionArgs,
        events: [],
      }
    );
    const evh_6705964765214521_clickPreventStop_5455 = new actions.EventHandlerImpl(
      {
        action: act_6705964765214521_script_5456,
        event: "click.prevent.stop",
        displayName: "script",
      }
    );
    const evh_6705964765214521_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_6705964765214521_clickPreventStop_5455],
      }
    );
    const act_8116269939469002_showModal_5458 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8116269939469002_showModal_5458_getActionArgs,
        events: [],
      }
    );
    const evh_8116269939469002_clickPreventStop_5457 = new actions.EventHandlerImpl(
      {
        action: act_8116269939469002_showModal_5458,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8116269939469002_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8116269939469002_clickPreventStop_5457],
      }
    );
    return {
      act_7315092382398562_closeModal_5452,
      evh_7315092382398562_close_5451,
      evh_7315092382398562_close,
      act_8320016629450276_reloadComponentData_5454,
      evh_8320016629450276_clickPreventStop_5453,
      evh_8320016629450276_clickPreventStop,
      act_6705964765214521_script_5456,
      evh_6705964765214521_clickPreventStop_5455,
      evh_6705964765214521_clickPreventStop,
      act_8116269939469002_showModal_5458,
      evh_8116269939469002_clickPreventStop_5457,
      evh_8116269939469002_clickPreventStop,
      reload: act_8320016629450276_reloadComponentData_5454,
    }
  }
}

Vue.component("MailAccountConfigurations", MailAccountConfigurations);

</script>